module.exports = __webpack_public_path__ + "img/7-Kablosan Turkey.00aaa7f5.png";